import React from 'react'
import DateUtils from 'utils/date'
import { DATE_HOUR_FORMAT } from 'constant'
import { Trans, useTranslation } from 'react-i18next'
import formatAlters from '../../../../utils/useFormattedAlters'
import './BundleLogs.scss'
import { BundleLogsPropsModel } from '../../models/bundle-logs-props.model'

const BundleLogs: React.FC<BundleLogsPropsModel> = ({ data }) => {
  const { t } = useTranslation()

  return (
    <>
      {data.length === 0 && (
        <div className='BundleLogs'>
          <h4>{t('bundle.history')}</h4>
          <p>{t('bundle.noHistory')}</p>
        </div>
      )}

      {data.length > 0 && (
        <div className='BundleLogs'>
          <h4 className={'BundleLogs__header'}>{t('bundle.history')}</h4>
          {data.map((history, i: number) => (
            <div
              className='BundleLogItem'
              key={i}
            >
              <div className='BundleLogItem__date'>
                {DateUtils.parseAndFormat(history.createdAt, DATE_HOUR_FORMAT)}
              </div>
              <div className='BundleLogItem__right'>
                {formatAlters(history.alters).map((entry, key) => (
                  <div key={key}>
                    <Trans
                      i18nKey='campaignHistory.alter'
                      values={entry.values}
                      components={entry.components}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default BundleLogs
